export default "__VITE_ASSET__BX2P8VfD__"